import { getState } from "../state/store";
import { selectGroupsByDusn } from "../state/selectors";

import { deviceGroupErrors, strCode } from "../consts";
import { t } from "../services";

const formatDeviceGroups = (deviceGroups) => {
  if (deviceGroups) {
    return deviceGroups?.map((group) => {
      return { id: group?.group_id, name: group?.group_name };
    });
  }

  return null;
};

const formatDeviceGroupsList = (deviceGroupsList) => {
  if (deviceGroupsList) {
    return deviceGroupsList?.map((deviceGroups) => {
      return { dusn: deviceGroups?.dusn, groupIds: deviceGroups?.group_ids };
    });
  }

  return null;
};

const getDeviceGroupsByDusn = (dusn) => {
  const deviceGroups = selectGroupsByDusn(dusn)(getState());
  const selectedGroups = deviceGroups?.map((group) => {
    return { id: group?.id, value: group?.name };
  });

  return selectedGroups;
};

const parseGroupsErrorMessage = (error) => {
  let errorMessage = deviceGroupErrors[error] ?? error;

  if (error?.includes("INVALID_PARAMETER_PROVIDED")) {
    const invalidParameter = error.split(":")[1];
    errorMessage = t(strCode.INVALID_PARAMETER_PROVIDED, { invalidParameter });
  }
  return errorMessage;
};

const deviceGroupUtils = {
  formatDeviceGroups,
  formatDeviceGroupsList,
  getDeviceGroupsByDusn,
  parseGroupsErrorMessage
};

export default deviceGroupUtils;
